import { createContext } from 'react';

export const HardwareIdContext = createContext<string | undefined>(undefined);
